// extracted by mini-css-extract-plugin
export default {"menu-background":"Menu_menu-background__kGGku","visible":"Menu_visible__fYdUi"};